export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 90,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_amz_fty_check_no') || '盘点单号',
    field: 'amzFtyCheckNo',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_inventory_time') || '盘点时间',
    field: 'createDate',
    width: 170,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_checked_by') || '盘点人',
    field: 'createByName',
    width: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_factory') || '成品工厂',
    field: 'scmName',
    minWidth: 230,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_bill_in_date') || '入库日期',
    field: 'inboundDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_location_no') || '库位编号',
    field: 'locationNo',
    minWidth: 160,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    sortable: true,
    sortType: 'string',
  },
  {
    title: that.$l('table_label_total_ctns') || '实盘箱数',
    field: 'totalCtns',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_total_goods_qty') || '产品数量',
    field: 'totalGoodsQty',
    minWidth: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_total_amount') || '成本金额',
    field: 'totalAmount',
    minWidth: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ cellValue }) =>
      !cellValue ? cellValue : cellValue.toLocaleString(undefined, { minimumFractionDigits: 2 }),
  },
]
